import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';

const WhatSetsUsApart = () => {
  return (
    <section
      id="recognition"
      data-testid="recognition-section"
      className="py-12 md:py-16 bg-white"
    >
      <div className="max-w-5xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-8"
        >
          <span className="text-[#2563EB] font-semibold text-sm uppercase tracking-wider">
            Recognition
          </span>
          <h2
            data-testid="recognition-headline"
            className="mt-3 font-['DM_Sans'] text-2xl sm:text-3xl font-semibold text-[#1C1917] tracking-tight"
          >
            Backed by India's most trusted institutions.
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-5">
          {/* T-Hub */}
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="bg-[#FAFAF9] rounded-2xl p-5 border border-[#E7E5E4] card-hover flex items-center gap-5"
          >
            <a
              href="https://t-hub.co"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white rounded-xl p-3 inline-flex shrink-0 border border-[#E7E5E4] hover:opacity-80 transition-opacity"
            >
              <img src="/thub-logo.svg" alt="T-Hub" className="h-10 w-10 object-contain" />
            </a>
            <div>
              <h3 className="font-['DM_Sans'] text-base font-semibold text-[#1C1917]">T-Hub</h3>
              <p className="text-xs text-[#78716C] mb-2">Hyderabad, Telangana</p>
              <div className="flex items-center gap-1.5 text-xs font-semibold text-[#16A34A]">
                <CheckCircle2 className="w-3.5 h-3.5" />
                T-Hub Recognised Startup
              </div>
            </div>
          </motion.div>

          {/* DPIIT Startup India */}
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="bg-[#FAFAF9] rounded-2xl p-5 border border-[#E7E5E4] card-hover flex items-center gap-5"
          >
            <a
              href="https://www.startupindia.gov.in"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white rounded-xl px-3 py-2.5 inline-flex shrink-0 border border-[#E7E5E4] hover:opacity-80 transition-opacity"
            >
              <img
                src="/dpiit-header.png"
                alt="DPIIT Startup India"
                className="h-10 object-contain"
              />
            </a>
            <div>
              <h3 className="font-['DM_Sans'] text-base font-semibold text-[#1C1917]">
                Startup India — DPIIT
              </h3>
              <p className="text-xs text-[#78716C] mb-2">Govt. of India</p>
              <div className="flex items-center gap-1.5 text-xs font-semibold text-[#16A34A]">
                <CheckCircle2 className="w-3.5 h-3.5" />
                DPIIT Recognised Startup
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default WhatSetsUsApart;
